/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type SbRespTradeSourcingBanner_itemSearch = {
    readonly pageType: string | null;
    readonly topCategoryL1: VerticalType | null;
    readonly " $refType": "SbRespTradeSourcingBanner_itemSearch";
};
export type SbRespTradeSourcingBanner_itemSearch$data = SbRespTradeSourcingBanner_itemSearch;
export type SbRespTradeSourcingBanner_itemSearch$key = {
    readonly " $data"?: SbRespTradeSourcingBanner_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespTradeSourcingBanner_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespTradeSourcingBanner_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "pageType",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "topCategoryL1",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = 'b75c715f8c31aba28022b723e3c0ff06';
export default node;
